import { render, staticRenderFns } from "./DeleteGroup.vue?vue&type=template&id=1082f662&"
import script from "./DeleteGroup.vue?vue&type=script&lang=js&"
export * from "./DeleteGroup.vue?vue&type=script&lang=js&"
import style0 from "./DeleteGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports